import React from 'react';

interface CalculatorInputProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  unit: string;
  placeholder?: string;
  label?: string;
  onClick?: () => void;
  isClickable?: boolean;
}

/**
 * A reusable input component with unit display for calculator forms
 */
const CalculatorInput: React.FC<CalculatorInputProps> = ({
  id,
  value,
  onChange,
  unit,
  placeholder,
  label,
  onClick,
  isClickable = false,
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // Only allow empty string or valid numbers with decimal point
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      onChange(value);
    }
  };

  return (
    <div className="input-box">
      {label && (
        <label
          htmlFor={id}
          onClick={isClickable ? onClick : undefined}
          className={isClickable ? 'clickable-text' : ''}
          tabIndex={isClickable ? 0 : undefined}
        >
          {label}
        </label>
      )}
      <div className="input-with-unit">
        <input
          id={id}
          type="text"
          inputMode="decimal"
          pattern="[0-9]*\.?[0-9]*"
          min="0"
          value={value}
          onChange={handleInputChange}
          placeholder={placeholder}
        />
        <span> {unit}</span>
      </div>
    </div>
  );
};

export default CalculatorInput;
